module.exports = __webpack_public_path__ + "img/tefal.897c1b42.jpeg";